import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Clock } from 'lucide-react';
import { Button } from '../components/ui/button';

const PendingApproval = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-8 text-center">
          <div className="flex items-center justify-center w-14 h-14 bg-amber-50 rounded-full mx-auto mb-6">
            <Clock className="w-7 h-7 text-amber-600" />
          </div>
          <h1 className="text-2xl font-bold text-slate-900" data-testid="pending-approval-title">
            Pending Approval
          </h1>
          <p className="mt-3 text-sm text-slate-500 leading-relaxed">
            Your password has been set. An administrator needs to approve your account before you can access full features.
          </p>
          <p className="mt-2 text-sm text-slate-500">
            You may browse the application in the meantime.
          </p>
          <Button
            onClick={() => navigate('/dashboard')}
            data-testid="proceed-btn"
            className="mt-8 w-full h-11 rounded-full bg-green-700 hover:bg-green-800"
          >
            Proceed
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PendingApproval;
